
import PageTitle from '@/UI/components/common/PageTitle.vue';
import { mixins } from 'vue-class-component';
import { SimpleProxyForm } from '@/UI/components/Helpers/SimpleProxyForm';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { Component } from 'vue-property-decorator';
import { Button, Menu, List, Row, Table, FormModel } from 'ant-design-vue';
// import { TasksTableMix } from '@/UI/mixins/Clients/TasksTableMix';
import { ContraindicationsFormData } from '@/form/Clients/Contraindications';
@Component({
    components: {
        PageTitle,
        BaseDataForm,
        'a-button': Button,
        'a-menu-item': Menu.Item,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,
        'a-table': Table,
        'a-row': Row,
        'a-form-model': FormModel,
        'a-form-model-item': FormModel.Item,
    },
})
export default class ClientContraindications extends mixins(SimpleProxyForm) {
    form = new ContraindicationsFormData();
    async created(): Promise<void> {
         try {
             this.formReady = true;
             this.tableLoad = true;
         } catch (err) {
             console.log('Clients task form Error');
         }
    }
}
